module.exports = __webpack_public_path__ + "static/media/background-circles.273ea1d1.svg";